// JavaScript Document
// USE ON THIS IS SECURITY, LEARN PAGES

import React from 'react'
import Header from './Header'
import SubHeader from './SubHeader'
import '../styles/global.css'
import '../styles/block2.css'

export default function ContentList(props) {
    
    return(
        
        <div class={props.divClass}>
        
            {props.data.map((content_group) => 
    
                <div class='row'>
                    
                    <Header id={content_group.anchor_id} divClass="col-12" styles={props.headerStyles} title={content_group.section_name}/>
                        
                    <div class={props.elementClass}>
                                              
                        <div class="leftSubHeader" dangerouslySetInnerHTML={{ __html: content_group.text }} />
    
                    </div>

                </div>
    
            )}
        
        </div>     
    
    );
}